import styled from 'styled-components'
import { themeGet } from 'styled-system'
import StepModalBackLink from './component'

export const StyledBackLink = styled(StepModalBackLink)`
  color: ${themeGet('colors.blue')};
  font-size: 1rem;
  font-weight: 600;
  font-family: ${themeGet('font.molde.regular')};
  display: flex;
  align-items: center;
  gap: 0.5rem;
`
